
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SettingReferenceModel } from "../../pages/setting-reference/models/SettingReferenceModel";
import { RootState } from "../../../setup/redux/Store";
export interface ISharedState {
   loading: boolean;
   allActiveSettingReference: SettingReferenceModel[];
}
const initialState: ISharedState = {
    allActiveSettingReference: [],
    loading: false,
    


}

export const sharedSlice = createSlice({
    name: "shared",
    initialState,
    reducers: {
        getAllActiveSettingReference: (state, action: PayloadAction<number>) => {
            state.loading = true;
        },
        setAllActiveSettingReference: (state, action: PayloadAction<SettingReferenceModel[]>) => {
            state.loading = false;
            state.allActiveSettingReference = action.payload;
        },       
        setTransactionFail: (state, action: PayloadAction<string>) => {
            state.loading = true;
        },
    },

})
export const {
    setAllActiveSettingReference,
    getAllActiveSettingReference,
    setTransactionFail,
} = sharedSlice.actions;

export const selectItemLoading = (state: RootState) => state.shared.loading;
export const selectAllActiveSettingReference = (state: RootState) => state.shared.allActiveSettingReference;
export default sharedSlice.reducer;
